import {TabState, TabStateDefaults} from 'Navigation';

export default class JellyfishTabState extends TabState {
  defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Jellyfish',
      closeable: false,
      preferenceKey: 'jellyfish',
    };
  }
}
